import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { UsersListContext } from "./UsersListContext";
import { UserContext } from "src/views/authentication/auth/UserContext";

export default function UsersListProvider({ children }) {
  const [usersList, setUsersList] = useState([]);
  const [loadingUsersList, setLoadingUsersList] = useState(true);
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!user?.email) {
      setUsersList([]);
      setLoadingUsersList(false);
      return;
    }

    const fetchAllUsers = async () => {
      try {
        setLoadingUsersList(true);
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_API_URL}/users`,
          {
            params: {
              page: 1,
              limit: 100,
              sortBy: "userName:asc",
            },
          }
        );

        const raw = Array.isArray(data) ? data : data.results || [];
        setUsersList(raw);
      } catch (err) {
        console.error("Failed to load users list:", err);
      } finally {
        setLoadingUsersList(false);
      }
    };

    fetchAllUsers();
  }, [user]);

  return (
    <UsersListContext.Provider value={{ usersList, setUsersList, loadingUsersList }}>
      {children}
    </UsersListContext.Provider>
  );
}